/**
 * Where a contractor's request stands, in a word.
 *
 * Since migration 064 a contractor can raise a ticket of their own - a request
 * to the firm for a licence, a part, an account. The approval decides it; the
 * ticket's status only says what happened afterwards, and a contractor who
 * asked for a licence wants to know whether anybody said yes, not that the
 * ticket is "Open". Read by the portal's Raised-by-me cards and by the
 * contractor's ticket page, so the two cannot disagree about the word.
 */
export const requestWord = (t) => {
  const a = String(t?.approval_status || 'pending').toLowerCase();
  if (a === 'approved') {
    const s = String(t?.status_name || t?.status || '').toLowerCase();
    if (s === 'closed' || s === 'resolved') return { key: 'done', label: 'Done' };
    return { key: 'approved', label: 'Approved' };
  }
  if (a === 'rejected' || a === 'declined') return { key: 'declined', label: 'Declined' };
  return { key: 'pending', label: 'Sent for approval' };
};
